/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { Fragment } from 'react'
import { emptyArray } from 'util/array'
import HistoricoDetailTable from 'view/atendimentos/detail/historico/components/table/HistoricoDetailTable'
import { SolicitacaoOciModel } from 'view/atendimentos/detail/soap/plano/exames/model-oci'

interface HistoricoPlanoSolicitacoesOciPanelProps {
  readonly solicitacoesOci: SolicitacaoOciModel[]
}

export default function HistoricoPlanoSolicitacoesOciPanel({
  solicitacoesOci,
}: HistoricoPlanoSolicitacoesOciPanelProps) {
  const solicitacoesOciOrdenadas = solicitacoesOci?.length
    ? [...solicitacoesOci].sort((a, b) => (b?.id ?? '').localeCompare(a?.id ?? ''))
    : emptyArray

  return (
    <HistoricoDetailTable hasLines title='Ofertas de Cuidados Integrados (OCI)'>
      <VFlow>
        {solicitacoesOciOrdenadas.map((solicitacao) => (
          <Grid gap={2} key={solicitacao.id}>
            {solicitacao.procedimentos.map(({ procedimento, observacao }) => (
              <Cell size={12} key={procedimento.id}>
                <Fragment>
                  <Text fontWeight='bold'>{procedimento.descricao.toUpperCase()}</Text>
                  <span>{` - ${procedimento.codigo}`}</span>
                  {observacao && <HLabel title='Observação do procedimento:'>{observacao}</HLabel>}
                </Fragment>
              </Cell>
            ))}
            {solicitacao.cid10 && (
              <Cell size={12} style={styles.paddingTopCid10}>
                <Text>
                  {solicitacao.cid10.nome} - {solicitacao.cid10.codigo} (CID10)
                </Text>
              </Cell>
            )}
            {solicitacao.justificativa && (
              <Cell size={12} style={styles.generalPaddingTop}>
                <HLabel title='Justificativa do procedimento:'>{solicitacao.justificativa}</HLabel>
              </Cell>
            )}
            {solicitacao.observacoes && (
              <Cell size={12} style={styles.generalPaddingTop}>
                <HLabel title='Observações:'>{solicitacao.observacoes}</HLabel>
              </Cell>
            )}
          </Grid>
        ))}
      </VFlow>
    </HistoricoDetailTable>
  )
}

const styles = {
  generalPaddingTop: css`
    padding-top: 0.25rem;
  `,
  paddingTopCid10: css`
    padding-top: 0.5rem;
  `,
}
